import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Stack, TextField, Divider, Link, Chip, Card, CardHeader, CardContent, Grid2 } from "@mui/material";
import { isStudent, useAuth } from "../../contexts/AuthContext";
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import { SampleData, AttemptedQuestionSampleData } from "./SampleData";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { StyledTableCell, StyledTableRow } from '../../theme';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from "react-router-dom";
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { InvokeAPI } from "../../apis/API";
import { getAssessmentMgmtBase } from "../../config/apiBase";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { ArrowBack, Assignment} from "@mui/icons-material";
import { AssessmentQuestionChatDialog, plainQuestionText } from "./AssessmentQuestionChatDialog";
import ClassIcon from '@mui/icons-material/Class';
import SchoolIcon from '@mui/icons-material/School';


const AssessmentUserReview = () => {
    const { id, userid } = useParams();
    const { user, logout } = useAuth();
    const [attemptDetails, setattemptDetails] = useState({});
    const isthisStudent = isStudent();
    const navigate = useNavigate();


    const RenderMeta = () => {
        const [createData, setCreateData] = useState({
            name: '',
            subject: '',
            class: '',
            status: '',
        });
        const getAssessmentMeta = async () => {
            const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/id`,
                { "ID": id },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            //console.log(uinfo.response)
            return uinfo.response["AssessmentInfo"]
        }

        useEffect(() => {
            //Some function
            getAssessmentMeta().then(data => setCreateData({ name: data.Aname, class: data.Aclass, subject: data.Asubject, status: data.Astatus }))
        }, [])
        return (
            <Box>
                <Card 
                    elevation={6}
                    sx={{
                        borderRadius: 4,
                        border: '1px solid',
                        borderColor: 'divider',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        '&:hover': {
                            boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                            transform: 'translateY(-2px)',
                        },
                    }}
                >
                    <CardHeader 
                        sx={{ textAlign: 'center', pb: 1 }}
                        title={
                            <Typography 
                                sx={{ 
                                    fontWeight: 600,
                                    fontSize: '1.125rem',
                                    color: 'text.primary',
                                    letterSpacing: '-0.01em',
                                    textAlign: 'center',
                                    width: '100%'
                                }} 
                                variant="h6"
                            >
                                Details
                            </Typography>
                        } 
                    />
                    <CardContent>
                        <Grid2 container spacing={4}>
                            <Grid2 size={{ xs: 12, sm: 12, md: 8 }}>
                                <Stack>
                                    <Box sx={{ paddingBottom: "10px" }}>
                                        <Stack direction="row" spacing={1} alignItems="center" sx={{ paddingBottom: "5px" }}>
                                            <Assignment color="primary" />
                                            <TextField
                                                label={createData.name ? "" : "Name"}
                                                variant="outlined"
                                                name="name"
                                                value={createData.name}
                                                sx={{
                                                    m: 1,
                                                    minWidth: '93%',
                                                    verticalAlign: 'middle',
                                                    '& .MuiOutlinedInput-root': {
                                                        backgroundColor: 'action.disabledBackground',
                                                        '& fieldset': {
                                                            borderColor: 'divider',
                                                        },
                                                        '&:hover fieldset': {
                                                            borderColor: 'divider',
                                                        },
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        cursor: 'default',
                                                    },
                                                }}
                                                InputLabelProps={{
                                                    shrink: false,
                                                }}
                                                slotProps={{
                                                    input: {
                                                        readOnly: true,
                                                    },
                                                }}
                                            />
                                        </Stack>
                                        <br></br>
                                    </Box>
                                    <Box sx={{ paddingBottom: "10px" }}>
                                        <Stack direction="row" spacing={1} alignItems="center" sx={{ paddingBottom: "5px" }}>
                                            <ClassIcon sx={{ color: "orange" }} />
                                            <TextField
                                                label={createData.subject ? "" : "Subject"}
                                                variant="outlined"
                                                name="subject"
                                                value={createData.subject}
                                                sx={{
                                                    m: 1,
                                                    minWidth: '44%',
                                                    verticalAlign: 'middle',
                                                    '& .MuiOutlinedInput-root': {
                                                        backgroundColor: 'action.disabledBackground',
                                                        '& fieldset': {
                                                            borderColor: 'divider',
                                                        },
                                                        '&:hover fieldset': {
                                                            borderColor: 'divider',
                                                        },
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        cursor: 'default',
                                                    },
                                                }}
                                                InputLabelProps={{
                                                    shrink: false,
                                                }}
                                                slotProps={{
                                                    input: {
                                                        readOnly: true,
                                                    },
                                                }}
                                            />
                                            <SchoolIcon sx={{ color: "brown" }} />
                                            <TextField
                                                label={createData.class ? "" : "Class"}
                                                variant="outlined"
                                                name="class"
                                                value={createData.class}
                                                sx={{
                                                    m: 1,
                                                    minWidth: '44%',
                                                    verticalAlign: 'middle',
                                                    '& .MuiOutlinedInput-root': {
                                                        backgroundColor: 'action.disabledBackground',
                                                        '& fieldset': {
                                                            borderColor: 'divider',
                                                        },
                                                        '&:hover fieldset': {
                                                            borderColor: 'divider',
                                                        },
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        cursor: 'default',
                                                    },
                                                }}
                                                InputLabelProps={{
                                                    shrink: false,
                                                }}
                                                slotProps={{
                                                    input: {
                                                        readOnly: true,
                                                    },
                                                }}
                                            />
                                        </Stack>
                                        <br></br>
                                    </Box>
                                </Stack>
                            </Grid2>
                        </Grid2>
                        <Box display="none">
                            Name:
                            <TextField
                                label=""
                                variant="outlined"
                                name="name"
                                value={createData.name}
                                sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            />

                            Subject:
                            <TextField
                                label=""
                                variant="outlined"
                                name="subject"
                                value={createData.subject}
                                sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            />
                            &nbsp;&nbsp;
                            Class:
                            <TextField
                                label=""
                                variant="outlined"
                                name="class"
                                value={createData.class}
                                sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            />
                        </Box>

                    </CardContent>
                </Card>
            </Box>
        );
    }

    const RenderMyAttempt = () => {
        const [review, setReview] = useState({ 'response': [] });

        const getAttemptReview = async (event) => {
            const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/attempt/review`,
                {
                    "Aid": id,
                    "UserID": userid,
                },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            //console.log(uinfo.response)
            //setReview({ 'student': event.target.value, 'response': uinfo.response["UserResponses"] })
            return uinfo.response
        };

        useEffect(() => {
            getAttemptReview().then(data => setReview({ 'response': data }))
        }, [id, userid])

        const [chatOpen, setChatOpen] = useState(false);
        const [chatQid, setChatQid] = useState("");
        const [chatQuestionNumber, setChatQuestionNumber] = useState(null);
        const [chatQuestionText, setChatQuestionText] = useState("");

        var qCount = 0

        const renderPassage = (passage) => {
            return (
                <Box sx={{ paddingBottom: '5px' }}>
                    <Accordion disableGutters sx={{
                        position: 'unset',
                        border: 'none',
                        boxShadow: 'none',
                        margin: '0 0',
                        '&:before': {
                            display: 'none',
                            border: 'none'
                        },
                        color: 'primary.main', boxShadow: "none", margin: "0", padding: "0"
                    }} >
                        <AccordionSummary disableGutters expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: "transparent", flexDirection: "row-reverse", padding: "0px 0px 0px 0px", margin: "0px 0px 0px 0px" }}>
                            <Typography component="span" sx={{ margin: "0", backgroundColor: "transparent" }}>Passage</Typography>
                        </AccordionSummary>
                        <AccordionDetails disableGutters sx={{ color: 'text.primary' }}>
                            <Typography sx={{ color: 'text.primary' }}>{passage}</Typography>
                        </AccordionDetails>
                    </Accordion>
                </Box>
            )
        }

        const renderDetails = (qlist) => {
            return (
                <Box sx={{ paddingBottom: '5px' }}>
                    <Accordion sx={{ border: 0, color: 'primary.main', boxShadow: "none" }} >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ flexDirection: "row-reverse", padding: "0px", margin: "0px" }}>
                            <Typography component="span">Details</Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ color: 'text.primary', margin: "0", padding: "0" }}>
                            <Box sx={{ padding: "0", margin: "0", color: 'text.primary' }}>
                                {qlist.Options.length !== 0 && <><b>Options:</b><br></br></>}
                                {qlist.Options.map((lrow, index) => (
                                    <>{qlist.Answer === lrow ?
                                        <>&nbsp;{index + 1}.&nbsp;<Chip label={lrow} color="success"></Chip><br></br></>
                                        :
                                        <>{qlist.Answer !== lrow && lrow === qlist.Rtext ?
                                            <><>&nbsp;{index + 1}.&nbsp;<Chip label={lrow} color="error"></Chip><br></br></></>
                                            :
                                            <>&nbsp;{index + 1}.&nbsp;{lrow}<br></br></>
                                        }
                                        </>
                                    }
                                    </>))}
                                {qlist.Options.length === 0 && <>
                                    <Typography component="span" sx={{ color: 'text.primary' }}>Answer: {qlist.Answer}</Typography><br></br>
                                    <Typography component="span" sx={{ color: 'text.primary' }}>Response: {qlist.Rtext}</Typography><br></br>
                                </>}
                                <br></br>
                                {qlist.Solution !== "" && <><Typography component="span" sx={{ color: 'text.primary' }}><b>Solution:</b> {qlist.Solution}</Typography></>}
                                <br></br>
                                {qlist.Feedback !== "" && <><Typography component="span" sx={{ color: 'text.primary' }}><b>Feedback:</b> {qlist.Feedback}</Typography></>}
                            </Box>
                        </AccordionDetails>
                    </Accordion>
                </Box>
            )
        }
        const renderSearchedQuestion = (qas) => {
            return (
                <>
                    {qas.Questions.map((qlist) => {
                        const qNum = ++qCount;
                        return (
                        <StyledTableRow key={qlist.QID}>
                            <StyledTableCell component="th" scope="row" width="10%">
                                {qNum}
                            </StyledTableCell>
                            <StyledTableCell component="th" scope="row">
                                {qas.MetaText !== "" && <>{renderPassage(qas.MetaText)}</>}
                                {qlist.Question}
                                {<>{renderDetails(qlist)}</>}
                            </StyledTableCell>
                            <StyledTableCell width="10%">
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'right', gap: 0.5, flexWrap: 'wrap' }}>
                                    {qlist.Rstatus === true && <IconButton size="small" disabled>
                                        <CheckCircleIcon sx={{ "color": "green" }} />
                                    </IconButton>}
                                    {qlist.Rstatus === false && isthisStudent && <>
                                        <IconButton size="small" disabled>
                                            <CancelIcon sx={{ "color": "red" }} />
                                        </IconButton>
                                    </>}
                                    {qlist.Rstatus === false && !isthisStudent && <>
                                        <Tooltip title="Discuss for deeper understanding">
                                            <span>
                                                <IconButton
                                                    size="small"
                                                    onClick={() => {
                                                        setChatQid(qlist.QID);
                                                        setChatQuestionNumber(qNum);
                                                        setChatQuestionText(plainQuestionText(qlist.Question));
                                                        setChatOpen(true);
                                                    }}
                                                    disabled={!userid}
                                                    aria-label="Open tutor chat for this question"
                                                >
                                                    <ChatBubbleOutlineIcon color="primary" />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                        <IconButton size="small" disabled>
                                            <CancelIcon sx={{ "color": "red" }} />
                                        </IconButton>
                                    </>}
                                </Box>
                            </StyledTableCell>
                            <StyledTableCell width="10%">
                                <Typography component="span" sx={{ color: 'text.primary' }}>{String(Math.floor(qlist.Rtime / 3600)).padStart(2, '0')}:</Typography>
                                <Typography component="span" sx={{ color: 'text.primary' }}>{String(Math.floor((qlist.Rtime % 3600) / 60)).padStart(2, '0')}:</Typography>
                                <Typography component="span" sx={{ color: 'text.primary' }}>{String(Math.floor(qlist.Rtime % 60)).padStart(2, '0')}</Typography>
                            </StyledTableCell>
                        </StyledTableRow>
                        );
                    })
                    }
                </>
            )
        }


        return (
            <>
            <Box>
                <Card 
                    elevation={6}
                    sx={{
                        borderRadius: 4,
                        border: '1px solid',
                        borderColor: 'divider',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                        overflow: 'hidden',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        '&:hover': {
                            boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                            transform: 'translateY(-2px)',
                        },
                    }}
                >
                    <CardHeader 
                        sx={{ textAlign: 'center', pb: 1 }}
                        title={
                            <Typography 
                                sx={{ 
                                    fontWeight: 600,
                                    fontSize: '1.125rem',
                                    color: 'text.primary',
                                    letterSpacing: '-0.01em',
                                    textAlign: 'center',
                                    width: '100%'
                                }} 
                                variant="h6"
                            >
                                Review Attempt
                            </Typography>
                        } 
                    />
                    <CardContent sx={{ pt: 3, p: 0, '&:last-child': { pb: 0 } }}>
                        <Box display="flex" justifyContent="center" alignItems="center" sx={{ py: 2 }}>
                            <Typography variant="h5" sx={{ fontWeight: 600, color: 'primary.main' }}>
                                Score: {review.response.Score}%
                            </Typography>
                        </Box>
                        <Box sx={{ 
                            borderRadius: '0 0 16px 16px', 
                            overflow: 'hidden',
                            padding: '0 12px 12px 12px'
                        }}>
                            <Box sx={{ borderRadius: '0 0 12px 12px', overflow: 'hidden' }}>
                                <TableContainer component={Paper} sx={{ paddingTop: '0px' }}>
                                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell
                                                    sx={{
                                                        borderTopLeftRadius: '12px',
                                                        '&:first-of-type': {
                                                            borderTopLeftRadius: '12px'
                                                        }
                                                    }}
                                                >
                                                    S No.
                                                </StyledTableCell>
                                                <StyledTableCell>Question</StyledTableCell>
                                                <StyledTableCell>Response</StyledTableCell>
                                                <StyledTableCell
                                                    sx={{
                                                        borderTopRightRadius: '12px',
                                                        '&:last-of-type': {
                                                            borderTopRightRadius: '12px'
                                                        }
                                                    }}
                                                >
                                                    Time Taken
                                                </StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {review && review.response && review.response.UserResponses && review.response.UserResponses.map((row) => (
                                                <>{renderSearchedQuestion(row)}</>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
            {!isthisStudent && <AssessmentQuestionChatDialog
                open={chatOpen}
                onClose={() => setChatOpen(false)}
                studentUserId={userid}
                assessmentId={id}
                questionId={chatQid}
                questionNumber={chatQuestionNumber}
                questionText={chatQuestionText}
                token={user["token"]}
                onAuthFailure={() => logout(user)}
            />}
            </>
        )
    }

    return (
        <Box sx={{ overflow: 'auto', scrollbarWidth: 'thin', paddingBottom: '80px' }}>
            <Button
                variant="text"
                startIcon={<ArrowBack />}
                onClick={() => navigate(-1)}
                sx={{ color: "blue" }}
            >
                Go Back
            </Button>
            <Stack>
                <RenderMeta />
                <Box sx={{ paddingBottom: "30px" }}></Box>
                <RenderMyAttempt />
            </Stack>
            <br></br>

        </Box>
    );
};

export default AssessmentUserReview;
